import React, { useState, useRef, useEffect, ChangeEvent } from 'react';
import { debounce } from '@variables/utils';
import {
  StyledSelectBox,
  StyledSelectButton,
  StyledSelectContents,
  StyledSearchInput,
  StyledSearchList,
} from './style';

interface listType {
  label: string;
  value: string;
  filterIdx?: number;
  keywordNum?: number;
}

interface SelectSearchProps {
  selectList: listType[];
  label: string;
  onChange: (e: string) => void;
}

const SelectSearch = ({ selectList, label, onChange }: SelectSearchProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterList, setFilterList] = useState<listType[]>([]);
  const [originFilterList, setOriginFilterList] = useState<listType[]>([]);
  const [filterText, setFilterText] = useState('');

  /**
   * 필터 디바운스
   */
  const debounceFilter = debounce((value: any) => {
    filterValueList(value);
  }, 500);

  /**
   * search filter data list 생성
   * @param e
   */
  const filterValueList = (e?: string) => {
    if (!e) {
      setFilterList(originFilterList);
      return;
    }

    let _filter: any = [];
    // 입력 데이터 소문자 치환
    const inputText = e.toLowerCase();
    // 데이터 가공
    selectList.forEach((data: listType) => {
      // keyword idx , length
      data.filterIdx = data.label.toLowerCase().indexOf(inputText);
      data.keywordNum = e.length;

      if (data.filterIdx > -1) {
        _filter.push(data);
      }
    });

    setFilterList(_filter);
  };

  /**
   * keyword 강조 반환
   */
  const keywordList = (data: any) => {
    const labelString = makeKeyword(data.label, data.filterIdx, data.keywordNum);

    return (
      <>
        {labelString.fstString}
        <em className="keyword">{labelString.keyString}</em>
        {labelString.endString}
      </>
    );
  };

  /**
   * 키워드 조합 생성
   * @param keyword
   * @param idx
   * @param keyNum
   */
  const makeKeyword = (keyword: string, idx: number, keyNum: number) => {
    let fstString = keyword;
    let keyString,
      endString = '';

    // tag 키워드 생성
    if (idx > -1 && keyNum) {
      fstString = idx === 0 ? '' : keyword.substring(0, idx);
      keyString = keyword.substring(idx, idx + keyNum);
      endString = keyword.substring(idx + keyNum, keyword.length);
    }

    return { fstString, keyString, endString };
  };

  /**
   * 자신 이외 선택시 close
   */
  const dropDownEl = useRef<any>(null);

  const handleClickOutside = ({ target }: MouseEvent) => {
    if (target) {
      if (isOpen && !dropDownEl.current?.contains(target)) {
        setIsOpen(false);
      }
      if (isOpen && !dropDownEl.current?.contains(target)) {
        setIsOpen(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    //초기 데이터 셋팅
    setOriginFilterList(selectList);
    setFilterList(selectList);
  }, []);

  return (
    <>
      <StyledSelectBox ref={dropDownEl}>
        <StyledSelectButton
          className={`${isOpen ? 'open' : ''}`}
          onClick={() => {
            filterValueList('');
            setFilterText('');
            setIsOpen(!isOpen);
          }}
        >
          {label}
        </StyledSelectButton>
        {isOpen && (
          <StyledSelectContents>
            <StyledSearchInput>
              <input
                type="text"
                value={filterText}
                onChange={(e) => {
                  setFilterText(e.target.value);
                  debounceFilter(e.target.value);
                }}
              />
              <button className="btn-search"></button>
            </StyledSearchInput>
            <StyledSearchList>
              {filterList.map((data, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      onChange(data.value);
                      setIsOpen(!isOpen);
                    }}
                  >
                    {keywordList(data)}
                  </li>
                );
              })}
            </StyledSearchList>
          </StyledSelectContents>
        )}
      </StyledSelectBox>
    </>
  );
};
export default SelectSearch;
